<template>
  <div>
    <v-container>
      <v-card class="mx-auto my-5" max-width="2500">
        <v-system-bar class="py-5 px-3" color="#1973a5" style="color: #fff" dark>
          Lista de hospitales</v-system-bar>
      </v-card>
      <v-card class="mx-auto my-5 elevation-1" max-width="2100">
        <v-row class="start ml-10" style="margin: 1rem 0">
          <v-col cols="6" sm="3" md="3" class="mx-3">
            <v-text-field max-width="200" class="mx-3" v-model="searchNombre" label="Nombre"
              prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <v-text-field max-width="200" class="mx-3" v-model="searchRUC" label="RUC" prepend-inner-icon="mdi-magnify"
              variant="outlined" hide-details single-line></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <v-btn color="#1973a5" dark style="margin:1rem" @click="openCreate">
              Agregar
            </v-btn>
          </v-col>
          <!-- <v-col cols="6" md="3">
            <v-btn icon color="#1973a5" style="margin-left: 3.5rem">
              Generar Excel<v-icon>mdi-arrow-down-bold-box</v-icon>
            </v-btn>
          </v-col> -->
        </v-row>
      </v-card>

      <v-card class="mx-auto my-5" max-width="2500">
        <!-- <v-btn
              color="#1973a5"
              dark
              style="margin:1rem"
              @click="cargaMasivaLista"
            >
              Carga Masiva
          </v-btn> -->
        <v-data-table :headers="header" :items="filteredData" class="elevation-1">
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="openEdit(item, item.idHospital)">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="openDelete(item)">
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="#1973a5" dark>
          <v-card-text>
            Cargando Datos
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEdit" v-if="dialogEdit" max-width="600px">
        <FormHospital @closeEdit="closeEdit" :idItem="idItemPadre" />
      </v-dialog>
      <v-dialog v-model="dialogDelete" v-if="dialogDelete" max-width="500px">
        <DeleteHospital @closeDelete="closeDelete" :sendData="idItemPadre" />
      </v-dialog>
    </v-container>
  </div>
</template>
<style>
.theme--dark.v-system-bar {
  background: linear-gradient(135deg, rgb(25 115 165), rgb(20 145 215), #0d67aa, #00304e) !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import FormHospital from "./form.vue"
import DeleteHospital from "./delete.vue"

export default {
  data() {
    return {
      dialogEdit: false,
      dialogDelete: false,
      dialogLoader: false,
      searchRUC: null,
      searchNombre: null,
      header: [
        { text: "Hospital", value: "hospital" },
        { text: "Ruc", value: "ruc" },
        { text: "Dirección", value: "direccion" },
        { text: "Inicio de actividades", value: "inicio_actividades" },
        { text: "Tipo", value: "tipo_institucion" },
        { text: "Acciones", value: "actions" }
      ],
      desserts: [],
      idItemPadre: {}
    }
  },
  methods: {
    openCreate() {
      this.idItemPadre = {};
      this.dialogEdit = true;
    },
    closeCreate() {
      this.idItemPadre = {};
      this.dialogEdit = false;
    },
    openEdit(item, id) {
      const array = { ...item, id_Hospital: id }
      console.log("datos que se envian al padre", array)
      this.idItemPadre = array;
      this.dialogEdit = true;
    },
    closeEdit() {
      this.idItemPadre = {};
      this.dialogEdit = false;
      this.listarHospitales();
    },
    openDelete(item) {
      this.idItemPadre = item;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.idItemPadre = {};
      this.dialogDelete = false;
      this.listarHospitales();
    },
    listarHospitales() {
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/generar_lista_hospital/", {}, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dialogLoader = false;
              this.desserts = res.data;
            })
            .catch((res) => {
              this.dialogLoader = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    }
  },
  mounted() {
    if (!sessionStorage.getItem("keyValue")) {
      this.$router.push("/");
    }
  },
  computed: {
    filteredData() {
      if (!this.searchNombre && !this.searchRUC) {
        return this.desserts;
      }
      let filtered = this.desserts;
      if (this.searchNombre) {
        filtered = filtered.filter((item) =>
          item.hospital
            .toLowerCase()
            .includes(this.searchNombre.toLowerCase())
        );
      }
      if (this.searchRUC) {
        filtered = filtered.filter((item) =>
          item.ruc
            .toLowerCase()
            .includes(this.searchRUC.toLowerCase())
        );
      }
      return filtered;
    },
  },
  created() {
    this.perfil = sessionStorage.getItem("perfil");
    this.nombre = sessionStorage.getItem("nombre");
    this.url = sessionStorage.getItem("url");
    this.usuario = sessionStorage.getItem("usuario");
    //INICIO DE CONSULTA
    this.listarHospitales();
  },
  components: {
    FormHospital,
    DeleteHospital
  },
};
</script>